export enum TOKEN {
  AUTH_TOKEN = 'auth-token',
  REFRESH_TOKEN = 'refresh-token'
}

export const TOKEN_REFRESH_THRESHOLD = 5 * 60; // 5 minutes => calls refresh token logic when access token is about to expire in 5 minutes
